<div class="center-modal">
  <div class="close" (click)="close()"></div>
  <div class="modal-container">
    <h1>{{title | translate}}</h1>
    @if (subtitle) {
      <p class="TextCentered">{{subtitle | translate}}</p>
    }
    <form #form="ngForm" (ngSubmit)="onConfirm()" novalidate>
      @if (type == 'confirmation') {
        <div class="L-12 M-12 S-12 columns TextCentered">
          <input name="sumbit" type="submit" value="{{confirmText | translate}}">
        </div>
        @if (!hideCancel) {
          <div class="L-12 M-12 S-12 columns TextCentered">
            <a class="button cancel" (click)="close()">{{cancelText | translate}}</a>
          </div>
        }
      }
      @if (type == 'choose') {
        <div class="L-12 M-12 S-12 columns TextCentered">
          <input name="sumbit" type="submit" value="{{confirmText | translate}}">
        </div>
        @if (!hideCancel) {
          <div class="L-12 M-12 S-12 columns TextCentered">
            <a class="button cancel" (click)="cancel()">{{cancelText | translate}}</a>
          </div>
        }
      }
    </form>
  </div>
</div>
